<template>
    <div>
        <div v-if="type === 1">
            <div class="txt-show">
                <img src="../../assets/error.png" alt="" width="62">
                <p class="title">操作失败</p>
                <p>此问题件，已移除或找不到对应问题件。</p>
                <p>请与承运商物流商客户联系。</p>
            </div>
            <div class="btn">
                <mt-button type="primary" @click="backProblem()">返回问题件查询</mt-button>
            </div>
        </div>
        <div v-if="type === 2">
            <div class="txt-show">
                <img src="../../assets/success.png" alt="" width="62">
                <p class="title">回复成功</p>
                <p>已收到您的问题件回复，我们会及时处理！</p>
                <p>之后您可以在<span>[我的VIP-问题件查询]</span>中查看到此问题件</p>
                <p>的处理状态。感谢您的回复，谢谢！</p>
            </div>
            <div class="btn">
                <mt-button type="primary" @click="backProblem()">返回问题件查询</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                type: 0
            }
        },
        created() {
          this.type = this.$route.query.type;
        },
        methods: {
            backProblem () {
                if (this.$route.query.fromList) {
                    this.$router.go(-1);
                } else {
                    this.$router.replace({name: 'Problem'});
                }
            }
        }
    }
</script>
<style scoped>
    .txt-show {
        text-align: center;
        color: #999;
        font-size: 12px;
        padding-top: 80px;
    }
    .txt-show span {
        color: #19a0ff;
    }
    .txt-show .title {
        color: #12131a;
        font-size: 20px;
        margin-top: 20px;
        margin-bottom: 8px;
    }
    .btn {
        text-align: center;
        margin-top: 60px;
    }
</style>


// WEBPACK FOOTER //
// src/page/problem/problem-result.vue